import { render } from "./AGCAREorderDetail.vue?vue&type=template&id=f8882198&scoped=true"
import script from "./AGCAREorderDetail.vue?vue&type=script&lang=js"
export * from "./AGCAREorderDetail.vue?vue&type=script&lang=js"

import "./AGCAREorderDetail.vue?vue&type=style&index=0&id=f8882198&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8882198"]])

export default __exports__